module.exports = __webpack_public_path__ + "media/images/icon_list/dashboard-dc9209dd47fd2afb604757cd466a9f68.svg";